/**
 *
 * Download Form
 *
 * UI for interacting with the download form
 */

const $ = require('jQuery');
const _LStorage = require('./utilities/_LStorage.js');
const _model = require('./utilities/_model.js');
const _Gsap = require('./utilities/_gsap');
const _Forms = require('./utilities/_form-controller.js');
const Deckable2 = require('./utilities/deckable2.js');
const { Foundation, dataLayer, ITBL } = window;
const disableSubmitButtonInForm = require('./src/run/form/disableSubmitButtonInForm');

var DownloadUI = function (el) {
    this.$el = $(el);
    this.$form = this.$el.find('.itbl-b-form');
    this.FormInstance = new Foundation.Abide(this.$form);

    //get all visible form input fields as array
    this.$visibleInputs = this.$form
        .find('select,checkbox,input:visible:not(input[type=submit])')
        .map((i, el) => el.getAttribute('name'))
        .get();
    this.$countryInput = this.$form.find('.itbl-b-select__country ');
    this.$marketingConsent = this.$form.find('[name=marketingConsent]');
    this.$privacyPolicy = this.$form.find('#iterables-privacy-policy-download');

    //known user elements
    this.$userName = this.$el.find('.itbl-c-form__username');
    this.$returningUserCTA = this.$el.find('.itbl-c-form__known-user-cta');
    this.$userEmailEl = this.$el.find('.itbl-c-form__user-email');
    this.$wrongUser = this.$el.find('.itbl-c-form__known-user-we-got-it-wrong');

    //success message SVG classes
    this.$confirmation = this.$el.find('.itbl-c-form__confirmation');
    this.$confirmationWrap = this.$el.find(
        '.itbl-b-form__confirmation-overflow'
    );

    this.$downloadImg = this.$el.find('.itbl-c-form__download-img');

    //these fields and event directly relate to the contact
    this.isContact = this.$form.hasClass('itbl-c-form-contact');
    this.$returningContactCTA = this.$el.find(
        '.itbl-c-form__known-user-contact'
    );
    this.enable_knownUser = Object.prototype.hasOwnProperty.call(
        ITBL,
        'enable_known_user'
    ) && !this.$el.hasClass('no-known-user');

    this.deckable = null;
    this.parsedData = null;

    //get the user email from localstorage
    this.userEmail = _LStorage.decrypt__get('iterable/encrypted/Email');
    this.userFirstName = _LStorage.decrypt__get('iterable/encrypted/FirstName');
    this.userLastName = _LStorage.decrypt__get('iterable/encrypted/LastName');
    this.userCompany = _LStorage.decrypt__get('iterable/encrypted/Company');
    this.userCountry = _LStorage.decrypt__get('iterable/encrypted/Country');
    //create an object of PII data from localstorage
    this.PII = this.helper__ContactForm_getEncryptedData();

    this.emailValues = {
        wp_email_to: 'forms@iterable.com',
        wp_email_subject: document.title + ' Webinar Form Registration',
        wp_email_message: null, //we gotta build this message body
    };

    this.APIState = Object.assign({}, this.emailValues);

    this.init();
};

DownloadUI.prototype.init = function () {
    //init the deckable class and turn on the loading spinner
    this.deckable = new Deckable2(this.$el, {}).showHideLoading(true);

    //init events
    this.events();

    /*******************
     *
     * ROUTER
     *
     */

    //so finally here, we call the controller function to do the routing
    try {
        if (this.userEmail && this.isContact) {
            //we are using the contact form, and we need to prepopulate the form fields with known values
            this.view__ContactForm_populateFields();

            //if we have the cached user email and the known-user feature has been enabled
        } else if (this.userEmail && this.enable_knownUser) {
            this.view__download_knownUser();
        } else {
            this.deckable.goToDeck('form');
        }
    } catch (e) {
        console.log('Router error ', e);
        this.deckable.goToDeck('form');
    }
};

DownloadUI.prototype.events = function () {
    //events
    this.$form
        .on('formvalid.zf.abide', () => {
            this.event__validFrom();
        })
        .on('submit', (e) => {
            e.preventDefault();
        });

    this.$wrongUser.on('click', this.event__goToForm.bind(this));

    this.$returningUserCTA.on(
        'click',
        this.event__downloadForm_returningUserFn.bind(this)
    );

    this.$returningContactCTA.on(
        'click',
        this.view__ContactForm_populateFields.bind(this)
    );

    this.$downloadImg.on('mouseenter', this.event__tada.bind(this));

    //shows the confirmation deck on CONF keyCode
    _Forms.event__keyCodeFn([67, 79, 78, 70], () => {
        this.deckable.goToDeck('confirmation');
    });

    //shows error message on ERO keyCode
    _Forms.event__keyCodeFn([69, 82, 79], () => {
        this.deckable.goToDeck('error');
    });

    //shows error message on KNOW keyCode
    _Forms.event__keyCodeFn([75, 78, 79, 87], () => {
        this.view__download_knownUser();
    });

    //testing
    this.$confirmationWrap.on('click', () => {
        this.helper__confirmationAnimations();
    });
};

/**
 * For this contact form - we will prepopulate input fields
 * @param event
 */
DownloadUI.prototype.view__ContactForm_populateFields = function (event) {
    if (typeof event !== 'undefined') {
        event.preventDefault();
    }

    try {
        //set the encypted fields in the form
        $.each(this.$visibleInputs, (i, v) => {
            var input = $(`[name=${v}]`);

            if (input.is('select')) {
                input.val(this.PII[v]).attr('selected', 'selected');
            } else if (this.PII[v] !== false && input.is(':checkbox')) {
                input.prop('checked', true);
            } else {
                input.val(!_model.empty(this.PII[v]) ? `${this.PII[v]}` : '');
            }
        });
    } catch (e) {
        console.log('Something weird happened with setting the vals ', e);
    } finally {
        //always show form
        this.deckable.goToDeck('form');
    }
};

/**
 * handles the event for valid form validation with form fills
 *
 * @returns {boolean}
 */
DownloadUI.prototype.event__validFrom = function () {
    //hide all decks
    this.deckable.hideAllDecks();

    //serialize this data into name/value
    _Forms.helper__addFormInputsToState(this.$form, this.APIState);

    //we have to manually check for this field to be checked
    if (this.$privacyPolicy.is(':checked')) {
        this.APIState.marketingConsent = 'true';
        this.$marketingConsent.val('true');
    } else {
        //if checkbox is not checked, explicitly set value to false as string, this will be converted into boolean by JSON
        this.APIState.marketingConsent = 'false';
    }

    //setup all encrypted values in localstorage
    _Forms.helper__setAllEncryptedVals(
        this.$visibleInputs,
        this.APIState
    );

    //replace the text with the user's name
    $(this.$userName).text(this.APIState.FirstName);

    disableSubmitButtonInForm(this.$form[0]);

    _Forms
        .marketo__submit(this.APIState, undefined, undefined, this.$form)
        .then(() => {
            //trigger Google Tag Manager event for Adwords conversion here!
            dataLayer.push({ event: 'ajaxFormSubmitted' });
        })
        .catch((e) => {
            console.log(e);
        })
        .finally(() => {
            _Forms.debug('finished API state', this.APIState);

            //there are no annimations for the contact form (as of now, so let's hide it)
            if (!this.isContact) {
                this.helper__confirmationAnimations();
            }

            //even though this submission failed, we are jumping to success anyway
            this.deckable.goToDeck('confirmation');
        });
};

//if email is available,
DownloadUI.prototype.view__download_knownUser = function () {
    //if there is no values from getting the decrypted local storage - then show the form
    if (!this.userEmail || !this.userFirstName || !this.userLastName) {
        this.deckable.goToDeck('form');
    }

    //replace the text with the user's name
    $(this.$userName).text(this.userFirstName);

    //replace the text with the user's email
    $(this.$userEmailEl).text(`(${this.userEmail})`);

    //jump to ungated slide
    this.deckable.goToDeck('known-user');
};

/**
 *  handles the click event for the download form
 *  Executes the form fill, marketo payload, and then takes users to the confirmation page
 * @param event
 */
DownloadUI.prototype.event__downloadForm_returningUserFn = function (event) {
    event.preventDefault();

    //select all the hidden fields
    _Forms.helper__getHiddenMetadata(this.$form, this.APIState);

    //get the email address/first name/ last name/company from API
    this.APIState.Email = this.userEmail;
    this.APIState.FirstName = this.userFirstName;
    this.APIState.LastName = this.userLastName;
    this.APIState.Company = this.userCompany;
    this.APIState.Country = this.userCountry;
    this.APIState.knownUser = 'true';

    //Show the loading biz
    this.deckable.hideAllDecks();

    //manually send data to marketo endpooint using save2
    _Forms
        .marketo__submit(this.APIState, undefined, undefined, this.$form)
        .then(() => {
            //trigger Google Tag Manager event for Adwords conversion here!
            dataLayer.push({ event: 'ajaxFormSubmitted' });
        })
        .catch((e) => {
            console.log(e);
        })
        .finally(() => {
            _Forms.debug('finished API state', this.APIState);

            //there are no annimations for the contact form (as of now, so let's hide it)
            if (!this.isContact) {
                this.helper__confirmationAnimations();
            }

            //even though this submission failed, we are jumping to success anyway
            this.deckable.goToDeck('confirmation');
        });
};

/**
 * Goes to the form deck
 * @param event
 */
DownloadUI.prototype.event__goToForm = function (event) {
    event.preventDefault();

    try {
        //important, we need to reset our values here, just in case there is data from somewhere else
        this.APIState = this.emailValues;
    } catch (e) {
        console.log(e);
    } finally {
        this.deckable.goToDeck('form');
    }
};

/**
 * handles the animation click event
 */
DownloadUI.prototype.helper__confirmationAnimations = function () {
    _Gsap.confirmationAnimation(this.$confirmationWrap);
};

/**
 * returns an object from of all localstorage encrypted data, this is used for prepopulating the form
 * @returns {{}}
 */
DownloadUI.prototype.helper__ContactForm_getEncryptedData = function () {
    return Object.keys(localStorage)
        .filter((key) => key.includes('iterable/encrypted'))
        .reduce((obj, key) => {
            var encryptedKey = key.split('/')[2];
            obj[encryptedKey] = _LStorage.decrypt__get(key);
            return obj;
        }, {});
};

DownloadUI.prototype.event__tada = function (event) {
    const target = $(event.target);

    $(target).itblAnimate('animated', 'tada');
};

$(document).ready(function () {
    $('.js-form-ui-init').each(function () {
        new DownloadUI(this);
    });
});
